import {
  CalculatorIcon,
  ClipboardListIcon,
  ClockIcon,
  PoundSterlingIcon,
} from "lucide-react";

import { IconData } from "simplydo/react/ui/icon";

export const IMPACT_TYPE_ICONS = {
  numerical: CalculatorIcon,
  money: PoundSterlingIcon,
  time: ClockIcon,
  dropdown: ClipboardListIcon,
} as const satisfies Record<string, IconData>;

export type ImpactTypeWithIcon = keyof typeof IMPACT_TYPE_ICONS;

/** Lucide kebab-case names persisted on create for backwards compatibility. */
export const IMPACT_TYPE_ICON_NAMES: Record<ImpactTypeWithIcon, string> = {
  numerical: "calculator",
  money: "pound-sterling",
  time: "clock",
  dropdown: "clipboard-list",
};

export function getImpactTypeIcon(type?: string | null): IconData | undefined {
  if (!type) return undefined;
  const normalized = type === "clock" ? "time" : type;
  if (!(normalized in IMPACT_TYPE_ICONS)) return undefined;
  return IMPACT_TYPE_ICONS[normalized as ImpactTypeWithIcon];
}

export function isTimeImpactType(type?: string | null): boolean {
  return type === "time" || type === "clock";
}
